import { render, staticRenderFns } from "./MemberTile.vue?vue&type=template&id=21b8151c"
import script from "./MemberTile.vue?vue&type=script&lang=ts"
export * from "./MemberTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports